import { createApiInstance } from './index';

const api = createApiInstance();

/**
 * 取得專案 config keys
 * @param {string} projectUuid
 * @param {string} acctEmail
 */
export const getConfigKeysByProjectId = async (projectUuid, acctEmail) => {
  const response = await api.post('get_config_keys_by_pid/', {
    project_uuid: projectUuid,
    acct_email: acctEmail,
  });
  return response.data;
};

/**
 * 建立 Config Key
 * @param {Object} payload
 */
export const createConfigKeyApi = async (payload) => {
  const response = await api.post('insert_config_key/', payload);
  return response.data;
};

/**
 * 編輯 Config Key
 * @param {Object} payload
 */
export const updateConfigKeyApi = async (payload) => {
  const response = await api.post('update_config_key/', payload);
  return response.data;
};

/**
 * 刪除 config key
 * 同一專案可能有多把同名 key（例如多把 GCP），帶 config_key_uuid 可精準定位
 * @param {Object} payload
 * @param {string} [payload.config_key_uuid]
 * @param {string} payload.key_name
 * @param {number|string} payload.project_no
 * @param {number} payload.status
 * @param {string} payload.source
 */
export const deleteConfigKey = async (payload) => {
  const response = await api.post('delete_config_key/', payload);
  return response.data;
};

/**
 * 設定專案的預設 config key（多把 GCP key 時決定單一憑證情境要用哪一把）
 * @param {Object} payload
 * @param {string} payload.config_key_uuid
 * @param {string} payload.project_uuid
 * @param {string} payload.acct_email
 */
export const setPrimaryConfigKeyApi = async (payload) => {
  const response = await api.post('set_primary_config_key/', payload);
  return response.data;
};

/**
 * 建立公司授權 License
 * @param {Object} payload
 */
export const createCompanyLicense = async (payload) => {
  const response = await api.post('create_company_license/', payload);
  return response.data;
};

/**
 * 編輯公司授權 License
 * @param {Object} payload
 * @param {string} payload.company_uuid
 * @param {string} payload.license_key
 */
export const insertCompanyLicense = async (payload) => {
  const response = await api.post('insert_company_license/', payload);
  return response.data;
};

/**
 * 取得公司 License
 * @param {string} companyUuid
 */
export const getCompanyLicense = async (companyUuid) => {
  const response = await api.post('get_company_license/', { company_uuid: companyUuid });
  return response.data;
};
